import { render, staticRenderFns } from "./prescriptionImage.vue?vue&type=template&id=61778bc8&scoped=true"
import script from "./prescriptionImage.vue?vue&type=script&lang=js"
export * from "./prescriptionImage.vue?vue&type=script&lang=js"
import style0 from "./prescriptionImage.vue?vue&type=style&index=0&id=61778bc8&prod&scoped=true&lang=css"
import style1 from "./prescriptionImage.vue?vue&type=style&index=1&id=61778bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61778bc8",
  null
  
)

export default component.exports